function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import vkPropTypes from "./vkPropTypes";

var Auth =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Auth, _React$Component);

  function Auth() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Auth.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mount();
  };

  _proto.mount = function mount() {
    var _this$props = this.props,
        vk = _this$props.vk,
        elementId = _this$props.elementId,
        options = _this$props.options;

    var copy = _objectSpread({}, options);

    copy.onAuth = function (uid, first_name, last_name, photo, photo_rec, hash) {
      return options.onAuth(uid, first_name, last_name, photo, photo_rec, hash);
    };

    vk.Widgets.Auth(elementId, copy);
  };

  _proto.render = function render() {
    var elementId = this.props.elementId;
    return React.createElement("div", {
      id: elementId
    });
  };

  return Auth;
}(React.Component);

_defineProperty(Auth, "defaultProps", {
  elementId: "vk_auth",
  options: {
    width: 300,
    onAuth: function onAuth() {}
  }
});

export { Auth as default };